module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAOCAQAAABedl5ZAAAAAXNSR0IArs4c6QAAAPpJREFUGNNdkDEvBFEUhS8RYgsSESESCbVqdwlbKvwAHQXFJn6DaLQTjf+xguS9c95IJAQJq9apFBQ6Jqw3k925Cs9mxrnlyTm55xMJuht123zBjq1IURfjZhMxv6js4JxbJzMiInI6hUsk1OLB857TYqr0ZYNKZeZWBDWkpUSPT0hchoaw/s+6sbO8ZmZXhXWm6HKPz1QqblsTiJgzjZfEVOnRjXfR4BsezDwieio9FgULfKfy06zZZTfGg1D8YSelNcw2lTle7ToidIJ1JgMighp/d/WYh1cSMxdoYL+8yh72QemgO+pXZTh2IwWKV0PYYJvfeETzD/APHeDbRRNMNZ4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/indexStyle3/code.png
// module id = XZb6
// module chunks = 1